import { TMargin } from '@libs/types';
import { CSSProperties } from 'react';

type TInlineStyles = {
    variables?: Record<string, string>;
    margin?: TMargin;
    color?: string;
    background?: string;
    fill?: string;
    width?: string;
    height?: string;
};

export const getInlineStyles = (options: TInlineStyles) => {
    const inlineStyles: CSSProperties = {};
    if (options.color) {
        inlineStyles.color = `var(--color-${options.color})`;
    }
    if (options.fill) {
        inlineStyles.fill = `var(--color-${options.fill})`;
    }
    if (options.background) {
        inlineStyles.background = `var(--color-${options.background})`;
    }
    if (options.width) {
        inlineStyles.width = options.width;
    }
    if (options.height) {
        inlineStyles.height = options.height;
    }
    if (options.variables) {
        Object.entries(options.variables)?.forEach(([key, value]) => {
            (inlineStyles as Record<string, string>)[`--${key}`] = value;
        });
    }

    if (options.margin) {
        if (options.margin.top !== undefined) inlineStyles.marginTop = options.margin.top;
        if (options.margin.right !== undefined) inlineStyles.marginRight = options.margin.right;
        if (options.margin.bottom !== undefined) inlineStyles.marginBottom = options.margin.bottom;
        if (options.margin.left !== undefined) inlineStyles.marginLeft = options.margin.left;
    }
    return Object.keys(inlineStyles).length > 0 ? inlineStyles : undefined;
};

export const capitalText = (text?: string) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
};
